import styled from '@emotion/styled';
import { tokens, Stack } from '@hotjar/hotsauce';

export const ChurnDeflectionModalStyles = {
  CtaContainer: styled(Stack)`
    justify-content: space-between;
    gap: ${tokens.spacer.x3};
    margin-bottom: ${tokens.spacer.x2};

    & > * {
      flex: 1;
    }
  `,
  ProductsContainer: styled.div`
    display: flex;
    padding: ${tokens.spacer.x2} 0 ${tokens.spacer.x4} 0;
    gap: ${tokens.spacer.x3};
    & > * {
      flex: 1;
    }
  `,
  ProductFeaturesContainer: styled.div`
    ${tokens.flexContainer('default', { gap: tokens.spacer.x1, direction: 'column' })}
  `,
  Stack: styled(Stack)`
    background-color: ${tokens.color.bg_info};
    border: 1px solid ${tokens.color.ui_border_light};
    border-radius: ${tokens.spacer.x0pt5};

    padding: ${tokens.spacer.x2};

    & > p {
      margin: 0;
    }
  `,
  FeaturesList: styled.ul`
    ${tokens.flexContainer('form', { gap: tokens.spacer.x1 })}
    list-style: none;
    margin: 0;
    padding: 0;
  `,
  FeatureItem: styled.li`
    ${tokens.flexContainer('default', { gap: tokens.spacer.x1 })}
  `,
};
